/* eslint-disable max-classes-per-file */
// Fix this
import 'rc-calendar/assets/index.css';
import 'rc-checkbox/assets/index.css';
import 'rc-select/assets/index.css';

import React, { Component, Fragment } from 'react';
import Calendar from 'rc-calendar';
import Checkbox from 'rc-checkbox';
import DatePicker from 'rc-calendar/lib/Picker';
import Loading from 'components/Loading/Loading';
import Select, { Option } from 'rc-select';
import classnames from 'classnames';
import moment from 'moment';
import omit from 'lodash/omit';
import { propsChanged } from 'utils/helperFunctions';
import { TIME_SLOTS } from 'config/constants';
import './style.css';

const dateFormat = 'ddd, MMM DD, YYYY';

const initialState = {
  startDate: null,
  endDate: null,
  startTime: undefined,
  endTime: undefined,
  isAllDay: false,
  errors: {}
};

class Picker extends Component {
  render() {
    const {
      disabled, disabledDate, onChange, placeholder, value
    } = this.props;

    const calendar = <Calendar disabledDate={disabledDate} />;
    return (
      <DatePicker
        animation="slide-up"
        disabled={disabled}
        calendar={calendar}
        value={value}
        onChange={onChange}
      >
        {({ value: myValue }) => {
          return (
            <div className="block-inputs__date-picker">
              <input
                placeholder={placeholder}
                disabled={disabled}
                readOnly
                value={(myValue && myValue.format(dateFormat)) || ''}
              />
            </div>
          );
        }}
      </DatePicker>
    );
  }
}

const TimeSelect = ({
  name, value, placeholder, onChange
}) => (
  <div className="block-inputs__time-picker">
    <Select
      dropdownClassName="rc-select-time-picker-dropdown"
      value={value}
      style={{ width: '100%' }}
      animation="slide-up"
      placeholder={<p>{placeholder}</p>}
      showSearch={false}
      onChange={myValue => onChange(name, myValue)}
    >
      {TIME_SLOTS.map((slot, index) => (
        <Option key={index} value={slot.label}>
          {slot.label}
        </Option>
      ))}
    </Select>
  </div>
);

class BlockInputs extends Component {
  constructor(props) {
    super(props);

    this.state = { ...initialState };
  }

  componentDidUpdate(prevProps) {
    if (propsChanged(['selectedBlock'], prevProps, this.props, true)) {
      this.loadDataFromBlock(this.props.selectedBlock);
    }
    if (prevProps.createBlockStatus !== 'SUCCESS' && this.props.createBlockStatus === 'SUCCESS') {
      this.setState(initialState);
    }
  }

  loadDataFromBlock = (block) => {
    if (block) {
      this.setState({
        startDate: moment(block.startDate),
        endDate: moment(block.endDate),
        startTime: TIME_SLOTS.find(slot => slot.value === block.startTime),
        endTime: TIME_SLOTS.find(slot => slot.value === block.endTime),
        isAllDay: block.startTime === 0 && block.endTime === 2400,
      });
    } else {
      this.setState(initialState);
    }
  }

  handleChange = (field, value) => {
    let { errors } = this.state;
    if (field === 'startDate' || field === 'endDate') {
      errors = omit(errors, ['dateRange']);
    } else if (field === 'startTime' || field === 'endTime') {
      errors = omit(errors, ['timeRange']);
    }

    this.setState({
      [field]: value,
      errors
    });
  }

  disabledEndDate = (endDate) => {
    if (!endDate) {
      return false;
    }

    const endDateText = endDate.format('YYYY-MM-DD');
    if (endDateText < moment().format('YYYY-MM-DD')) {
      return true;
    }

    const { startDate } = this.state;
    if (!startDate) {
      return false;
    }

    return endDateText < startDate.format('YYYY-MM-DD');
  }

  disabledStartDate = (startDate) => {
    if (!startDate) {
      return false;
    }

    const startDateText = startDate.format('YYYY-MM-DD');
    if (startDateText < moment().format('YYYY-MM-DD')) {
      return true;
    }

    const { endDate } = this.state;
    if (!endDate) {
      return false;
    }
    return startDate.format('YYYY-MM-DD') > endDate.format('YYYY-MM-DD');
  }

  handleClear = () => {
    const { onClear } = this.props;
    onClear && onClear();

    this.setState(initialState);
  }

  handleSave = () => {
    const { onSave, selectedBlock } = this.props;
    const {
      startDate, endDate, startTime, endTime, isAllDay
    } = this.state;

    const startTimeSlot = TIME_SLOTS.find(slot => slot.label === startTime);
    const endTimeSlot = TIME_SLOTS.find(slot => slot.label === endTime);

    const errors = {};
    if (!startDate || !endDate) {
      errors.dateRange = 'Date range should not be empty';
    }

    if (!isAllDay) {
      if (!startTime || !endTime) {
        errors.timeRange = 'Time range should not be empty';
      } else if (startTimeSlot.value >= endTimeSlot.value) {
        errors.timeRange = 'EndTime must be greater than StartTime';
      }
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
      return;
    }

    let blockData = {
      startDate,
      endDate,
      repeats: false,
      repeat: {
        frequency: 'Y',
        interval: 12,
        weekdays: '',
        monthDay: '',
        monthType: ''
      }
    };

    if (isAllDay) {
      blockData = {
        ...blockData,
        startTime: 0,
        endTime: 0,
        allDay: true
      };
    } else {
      blockData = {
        ...blockData,
        startTime: startTimeSlot.value,
        endTime: endTimeSlot.value
      };
    }

    onSave && onSave(selectedBlock && selectedBlock.id, blockData);
  }

  render() {
    const { createOrUpdateError, createBlockStatus, updateBlockStatus } = this.props;
    const {
      startDate, endDate, startTime, endTime, isAllDay, errors
    } = this.state;

    return (
      <div className="block-inputs mt-4">
        <div className="block-inputs__field block-inputs__field--date mb-4">
          <div className="block-inputs__field-label d-flex align-items-center justify-content-between mb-3">
            <h6 className="m-0">Date(s)</h6>
            <label className="block-inputs__checkbox m-0 btn-cursor">
              <Checkbox
                name="all-day"
                checked={isAllDay}
                onChange={() => this.handleChange('isAllDay', !isAllDay)}
              />
              &nbsp; All day
            </label>
          </div>
          <div className="block-inputs__field-value block-inputs__field-value--date d-flex align-items-center">
            <Picker
              placeholder="Start Date"
              disabledDate={this.disabledStartDate}
              value={startDate}
              onChange={value => this.handleChange('startDate', value)}
            />
            <img
              src="/assets/right-arrow.png"
              style={{ width: 19 }}
              className="mx-4 mx-lg-2 mx-xl-4"
              alt="arrow"
            />
            <Picker
              placeholder="End Date"
              disabledDate={this.disabledEndDate}
              value={endDate}
              onChange={value => this.handleChange('endDate', value)}
            />
          </div>
          {errors.dateRange && (
            <p className="block-inputs__field-error text-danger mt-2">{errors.dateRange}</p>
          )}
        </div>
        <div className="block-inputs__field block-inputs__field--time mb-4">
          <div className="block-inputs__field-label d-flex align-items-center justify-content-between mb-3">
            <h6 className="m-0">Time(s)</h6>
          </div>
          <div
            className={classnames('block-inputs__field-value d-flex align-items-center', {
              'block-inputs__field-value--all-day': isAllDay
            })}
          >
            {isAllDay ? (
              'All day'
            ) : (
              <Fragment>
                <TimeSelect
                  value={startTime}
                  name="startTime"
                  placeholder="Start Time"
                  onChange={this.handleChange}
                />
                <img
                  src="/assets/right-arrow.png"
                  style={{ width: 19 }}
                  className="mx-4 mx-lg-2 mx-xl-4"
                  alt="arrow"
                />
                <TimeSelect
                  value={endTime}
                  name="endTime"
                  placeholder="End Time"
                  onChange={this.handleChange}
                />
              </Fragment>
            )}
          </div>
          {errors.timeRange && (
            <p className="block-inputs__field-error text-danger mt-2">{errors.timeRange}</p>
          )}
        </div>
        <div className="block-inputs__field d-flex">
          {createBlockStatus === 'LOADING' || updateBlockStatus === 'LOADING' ? (
            <div>
              <Loading size="small" />
            </div>
          ) : (
            <Fragment>
              <button
                type="button"
                className="btn btn-primary btn-blue btn-cursor btn-lg btn-teacher-dashboard"
                onClick={this.handleSave}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-cursor btn-lg btn-teacher-dashboard ml-2"
                onClick={this.handleClear}
              >
                Clear
              </button>
            </Fragment>
          )}
        </div>
        {createOrUpdateError && (
          <p className="block-inputs__field-error text-danger mt-2">{createOrUpdateError}</p>
        )}
      </div>
    );
  }
}

export default BlockInputs;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Availability/Specific/BlockInputs/index.js